// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-040e4b0a]{width:20px;height:20px;transform:translateY(5px);margin-right:5px}svg .outer[data-v-040e4b0a]{fill:none;stroke:var(--dark-blue);stroke-width:2px;stroke-miterlimit:10}svg .inner[data-v-040e4b0a]{fill:var(--green);transform:scale(0);transform-origin:center;transition:transform .15s}svg.active .inner[data-v-040e4b0a]{transform:scale(1)}", ""]);
// Exports
module.exports = exports;
